import { formNames, MktSelectors } from '@wkda/carlead-creation-form';
import { BaseField, renderFieldVerticalWrapper } from '../BaseField';
import { boxSelectRenderer } from '../fieldRenderers/boxFieldRenderer';
import { useAutoSelectForDataFields, useSyncValues } from '../hooks/useAutoSelectForDataFields';
import { useDynamicCartypesFetcher } from '../hooks/useDynamicCartypesFetcher';
import { useStateMachineForDataFields } from '../hooks/useStateMachineForFields';
import { jsx as _jsx } from "react/jsx-runtime";
export function GenericFieldBoxSelect(_ref) {
  let {
    name,
    dataQueryFn,
    columnClassName = 'col-6',
    label,
    className: _className,
    onChange,
    ...props
  } = _ref;
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames,
    fieldFetchParams
  } = useStateMachineForDataFields({
    name
  });
  const {
    data
  } = useDynamicCartypesFetcher({
    name,
    enabled: isFieldEnabled,
    queryFn: dataQueryFn,
    params: fieldFetchParams
  });
  useAutoSelectForDataFields(name, data);
  useSyncValues(name);
  return data.length > 0 ? /*#__PURE__*/_jsx(BaseField, {
    label: label,
    name: formNames[name],
    renderFieldWrapper: renderFieldVerticalWrapper,
    topContainerClassName: stateFieldClassNames,
    renderFieldComponent: function fieldRenderer(_ref2) {
      let {
        name,
        mktSelector
      } = _ref2;
      return boxSelectRenderer({
        name: name,
        mktSelector,
        columnClassName,
        options: data,
        onChange(value) {
          onChange === null || onChange === void 0 || onChange(value);
          sendUserSelect(value);
        }
      });
    },
    MktSelector: MktSelectors[name],
    ...props
  }) : null;
}